module.exports = __webpack_public_path__ + "static/media/Andrina 5.fe25f08d.png";